const getStoredScreenshotPresetKey = (widgetId: string): Nullable<string> =>
  widgetId ? `screenshotPreset${widgetId}` : null;

export default getStoredScreenshotPresetKey;
